import {isFolder, type FoldersAndBookmarks} from 'types';
import {AdminBookmarkCard, AdminBookmarkFolderCard} from '../cards';
import AdminBookmarksCardGridItem from '../AdminBookmarksCardGridItem';

type AdminBookmarksRootViewProps = {
  foldersAndUnfoldedBookmarks: FoldersAndBookmarks;
  createFolderClickHandler: Function;
}

const AdminBookmarksRootView = ({ foldersAndUnfoldedBookmarks, createFolderClickHandler } : AdminBookmarksRootViewProps) => {
  return <>
    {foldersAndUnfoldedBookmarks.map(folderOrBookmark => (
      <AdminBookmarksCardGridItem key={folderOrBookmark.key}>
        {isFolder(folderOrBookmark)
        ? <AdminBookmarkFolderCard
            folder={folderOrBookmark}
            onClick={createFolderClickHandler(folderOrBookmark)}
          />
        : <AdminBookmarkCard
            bookmark={folderOrBookmark}
          />
        }
      </AdminBookmarksCardGridItem>
    ))}
  </>
}

export default AdminBookmarksRootView;